var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "example" },
    [
      _c(
        "b-card",
        [
          _c(
            "b-card-header",
            [
              _c("b-card-title", [
                _vm._v("Inventory Value per Product Category"),
              ]),
            ],
            1
          ),
          _vm.validData.length > 0
            ? _c(
                "div",
                [
                  _c("apexchart", {
                    attrs: {
                      type: "pie",
                      height: "350",
                      options: _vm.chartOptions,
                      series: _vm.series,
                    },
                  }),
                ],
                1
              )
            : _c("div", { staticClass: "text-center py-5" }, [
                _c("i", {
                  staticClass: "fas fa-chart-pie text-muted mb-3",
                  staticStyle: { "font-size": "3rem" },
                }),
                _c("h4", { staticClass: "text-muted" }, [
                  _vm._v("No Inventory Value Data Available"),
                ]),
                _c("p", [
                  _vm._v(
                    "There is no inventory value data for the selected date range. Try selecting a different period."
                  ),
                ]),
              ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }